module.exports = __webpack_public_path__ + "media/components/country-flag/static/mt-678ecf0e03ef6516d6b9cb31b43ec343.svg";